import { render, staticRenderFns } from "./IncomeRange.vue?vue&type=template&id=488d59d2&scoped=true&"
import script from "./IncomeRange.vue?vue&type=script&lang=ts&"
export * from "./IncomeRange.vue?vue&type=script&lang=ts&"
import style0 from "./IncomeRange.vue?vue&type=style&index=0&id=488d59d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d59d2",
  null
  
)

export default component.exports